module.exports = __webpack_public_path__ + "static/img/screenshot-bg.f136421.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/screenshot-bg.png
// module id = 6iEg
// module chunks = 36